import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { Loading } from '../../common/loading'
import ErrorCustom, { errorTypes } from '../../errors/ErrorCustom'
import { SaveRoute } from '../../layout/SaveRoute'
import { Content } from './Content'
import { getProfileDefault } from './createEditProfile/store/thunk'
import { EditProfile } from './editProfile'
import './i18n'
import { selectLoading, selectProfileById } from './store/slice'
import { getAlertSettingsDynamic } from './store/thunk'

export const SETTING_SCROLL_ID = 'SETTING_SCROLL_ID'

const AlertSetting = () => {
  const dispatch = useDispatch()
  const [searchParams] = useSearchParams()

  const locale = useSelector((state) => state.i18n.locale)
  const isLoading = useSelector(selectLoading('settings'))
  const profileById = useSelector(selectProfileById())

  const detailProfileId = searchParams.get('profileId')

  useEffect(() => {
    dispatch(getAlertSettingsDynamic())
    dispatch(getProfileDefault())
  }, [locale])

  if (isLoading) {
    return <Loading />
  }

  if (detailProfileId) {
    if (profileById[detailProfileId]) {
      return <EditProfile />
    } else {
      return <ErrorCustom errorType={errorTypes.NOT_FOUND} />
    }
  }

  return (
    <SaveRoute>
      <Content />
    </SaveRoute>
  )
}

export default AlertSetting
